import { useQuery } from "@tanstack/react-query";
import type { YouTubeOverviewItem } from "shared";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

export const useYouTubeOverview = (enabled = true) =>
	useQuery({
		queryKey: QueryKeys.Integrations.YouTube.Overview(),
		queryFn: () => Api.GetYouTubeOverview().then((r) => r.data),
		enabled,
	});

export type { YouTubeOverviewItem };
